module.exports = __webpack_public_path__ + "static/media/hidratacion42k.b7fc9113.webp";